import { TwoColOneAd } from "./two-col-one-ad.js";
import { HalfImageSlider } from "./half-screen-slider.js";
import { FullscreenSimpleSlider } from "./fullscreen-simple-slider.js";
import { FullscreenLinearGallerySlider } from "./fullscreen-linear-gallery-slider.js";
import { ThreeCol } from "./three-col.js";
import { TwoCol } from "../two-col/two-col.js";
import { LShapeOneWidget } from "../l-shape/l-shape-one-widget.js";
import { FullImageSlider } from "./full-screen-slider.js";
import { TwoColCarousel } from "./two-col-carousel.js";
import { TwoColHighlight } from "./two-col-highlight.js";
import { FourColGrid } from "./four-col-grid.js";
import { AdSlotRow } from "./ad-slot-row";
import { CustomWidgetRow } from "./custom-widget-row";
import { OneColStoryList } from "./one-col-story-list.js";
import { SliderCollectionOfCollections } from "./slider-collection-of-collections.js";
import { ThreeColGrid } from "./../collection-templates/three-col-grid/three-col-grid.js";

import {
  ThreeColGrid as ArrowThreeColGrid,
  FourColGrid as ArrowFourColGrid,
  ElevenStories as ArrowElevenStories,
  OneColStoryList as ArrowOneColStoryList,
  TwoColThreeStories as ArrowTwoColThreeStories,
  ThreeColSixStories as ArrowThreeColSixStories,
  TwoColFourStories as ArrowTwoColFourStories,
  HalfScreenSlider as ArrowHalfScreenSlider,
  FullScreenSlider as ArrowFullScreenSlider,
  FourStorySlider as ArrowFourStorySlider,
  ThreeColSevenStory as ArrowThreeColSevenStory,
  CollectionFilter as ArrowCollectionFilter
} from "@quintype/arrow";

import { arrowWrapper } from "./arrow/index.js";

export default {
  HalfImageSlider,
  TwoColOneAd,
  FullscreenSimpleSlider,
  ThreeCol,
  FullscreenLinearGallerySlider,
  TwoCol,
  TwoColHighlight,
  TwoColCarousel,
  LShapeOneWidget,
  FullImageSlider,
  FourColGrid,
  OneColStoryList,
  SliderCollectionOfCollections,
  ThreeColGrid,
  CollectionFilter: arrowWrapper(ArrowCollectionFilter),
  ArrowThreeColGrid: arrowWrapper(ArrowThreeColGrid),
  ArrowFourColGrid: arrowWrapper(ArrowFourColGrid),
  ArrowOneColStoryList: arrowWrapper(ArrowOneColStoryList),
  ArrowThreeColSixStories: arrowWrapper(ArrowThreeColSixStories),
  ArrowTwoColThreeStories: arrowWrapper(ArrowTwoColThreeStories),
  ArrowElevenStories: arrowWrapper(ArrowElevenStories),
  ArrowTwoColFourStories: arrowWrapper(ArrowTwoColFourStories),
  ArrowHalfScreenSlider: arrowWrapper(ArrowHalfScreenSlider),
  ArrowFullScreenSlider: arrowWrapper(ArrowFullScreenSlider),
  ArrowFourStorySlider: arrowWrapper(ArrowFourStorySlider),
  ArrowThreeColSevenStory: arrowWrapper(ArrowThreeColSevenStory),
  Leaderboard: AdSlotRow,
  SuperLeaderboard: AdSlotRow,
  Billboard: AdSlotRow,
  Custom: AdSlotRow,
  widget: CustomWidgetRow,
  defaultTemplate: ThreeCol
};
